import { BrowserRouter } from 'react-router-dom';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { RouterConfig } from '@navigation/routerconfig';
import { useAppDispatch } from '@hooks/statehooks';

import useWindowSize from '@hooks/usewindowsize';
import { telemetryService } from '@services/telemetryservice';
import { install } from 'resize-observer';
import { updateReferrer } from '@store/reducers/navigate';

import '@styles/app.scss';
import { appInsightsInstrumentationKey } from '@services/constants';
import {
  businessContractHire,
  contractTypeQueryStringName,
  siteWidePersonalBusinessToggleSelector,
} from './constants';
import { PricingType } from './enums';
import { updateVehiclePricingType } from '@store/reducers/vehicleinformation';

const ai = telemetryService(appInsightsInstrumentationKey);
const initialized = ai.initialize();

function App() {
  install();
  useWindowSize();

  const dispatch = useAppDispatch();

  dispatch(updateReferrer({ referrer: document.referrer }));

  const checkContractTypeQueryString = () => {
    let params = new URLSearchParams(window.location.search);
    if (params.has(contractTypeQueryStringName)) {
      let contractType = params.get(contractTypeQueryStringName);
      if (
        contractType &&
        contractType.toLowerCase() === businessContractHire.toLowerCase()
      ) {
        if (
          document.getElementById(
            siteWidePersonalBusinessToggleSelector
          ) as HTMLInputElement
        ) {
          (
            document.getElementById(
              siteWidePersonalBusinessToggleSelector
            ) as HTMLInputElement
          ).checked = true;
          dispatch(updateVehiclePricingType(PricingType.Business));
        }
      }
    }
  };

  checkContractTypeQueryString();

  return (
    <BrowserRouter>
      <RouterConfig />
    </BrowserRouter>
  );
}

export default initialized
  ? withAITracking(ai.reactPlugin, App, 'Configurator')
  : App;
